// menuMap.ts
export const menuHierarchy: { [key: string]: { label: string; parent?: string } } = {
  // Top-level items
  dashboard: { label: 'Dashboard' },
  'report-center': { label: 'Report Center' },
  'payment-gatewaye': { label: 'Payment Gateway' },

  // Master (section)
  Master: { label: 'Master' },
  category: { label: 'Category', parent: 'Master' },
  route: { label: 'Route', parent: 'Master' },
  routecity: { label: 'Route City', parent: 'Master' },

  Location: { label: 'Location', parent: 'Master' },
  zone: { label: 'Zone', parent: 'Location' },
  'corporate-zone': { label: 'Corporate Zone', parent: 'Location' },

  Area: { label: 'Area', parent: 'Master' },
  district: { label: 'District', parent: 'Area' },
  block: { label: 'Block', parent: 'Area' },
  counter: { label: 'Counter', parent: 'Area' },
  taluk: { label: 'Taluk', parent: 'Area' },
  constituency: { label: 'Constituency', parent: 'Area' },
  ward: { label: 'Ward', parent: 'Area' },
  union: { label: 'Union', parent: 'Area' },
  state: { label: 'state', parent: 'Area' },






  // Products
  Products: { label: 'Products' },
  'main-group': { label: 'Main Group', parent: 'Products' },
  'sub-group': { label: 'Sub Group', parent: 'Products' },
  product: { label: 'Product', parent: 'Products' },
  uom: { label: 'UoM', parent: 'Products' },
  producttax: { label: 'Product tax', parent: 'Products' },
  productavailability: { label: 'Product Availability', parent: 'Products' },
  productprice: { label: 'Product Price', parent: 'Products' },



  // Party
  Party: { label: 'Party' },
  agent: { label: 'Agent', parent: 'Party' },
  droppingpoint: { label: 'Dropping Point', parent: 'Party' },
  customer: { label: 'Customer', parent: 'Party' },
  consumer: { label: 'Consumer', parent: 'Party' },
  employee: { label: 'Employee', parent: 'Party' },




  // vehicle
  Vehicle: { label: 'Vehicle' },
  transport: { label: 'Vehcle Transport', parent: 'Vehicle' },
  vehicletype: { label: 'Type', parent: 'Vehicle' },
  vehiclesetup: { label: 'Setup', parent: 'Vehicle' },



  // Sales
  Sales: { label: 'Sales' },
  agentorder: { label: 'Agent Order', parent: 'Sales' },
  agentorderliter: { label: 'Agent Order Liter', parent: 'Sales' },
  consumerorder: { label: 'Consumer Order', parent: 'Sales' },
  productinvoice: { label: 'Product Invoice', parent: 'Sales' },
  prepareindent: { label: 'Prepare Indent', parent: 'Sales' },
  employeefreemilk: { label: 'Employee Free Milk', parent: 'Sales' },
  purchase: { label: 'Purchase'}



  // You can continue this pattern...
};